import { tracPageUpdated } from '@webapp/utils/rudderstack/events';

import SimpleArtist from '@common/types/artist/simple-artist';
import TracPage from '@services/tracpage/types/trac-page';

interface Props {
  artistData: SimpleArtist;
  artistTracPage?: TracPage;
}

export const updatedTracPageSideEffect = async ({
  artistData,
  artistTracPage,
}: Props) => {
  const updateData = {
    artist_id: artistData.id,
    artist_name: artistData.name,
    custom_background: !!artistTracPage?.background,
    theme: artistTracPage?.theme,
    integrations: artistTracPage?.data.social.map((social) => ({
      name: social.provider,
      value: social.url,
    })),
    links_headers: artistTracPage?.links.map((link) => ({
      url: link.url,
      type: link.type,
      title: link.title,
    })),
  };

  await tracPageUpdated(updateData);
};
